export type FilmData = {
  titleinformation: {
    asset_id: string;
    title: string;
    language: string;
    director: string;
    year: string;
  }[];
  assetReportInforamtions: {
    title: string;
    asset_id: string;
    element: string;
    element_sub_type: string;
    film_base: string;
    can_size: string; // You might want to specify the correct type here
    film_gauge: string | null; // You might want to specify the correct type here
    reel_no: string; // You might want to specify the correct type here
    total_no_of_cans: string; // You might want to specify the correct type here
    total_no_of_reels: string; // You might want to specify the correct type here
  }[];
  reelAnalysisStatuses: {
    analysis_date: string; // You might want to specify the correct type here
    editor_checker_name: string;
    preservation_condition__decay_AD_strip_value: string; // You might want to specify the correct type here
    film_status_1: string;
    film_status_2: string;
    film_status_3: string;
    film_status_scale: string;
    foreign_matters_1: string;
    foreign_matters_2: string;
    foreign_matters_3: string;
    shrinkage: string;
    physical_damage_1: string;
    physical_damage_2: string;
    physical_damage_3: string;
    emulsion_scratches: string;
    emulsion_scratches_scale: string;
    coating: string;
    base_scratches: string;
    base_scratches_scale: string;
    next_processing_step_recommended_by_edit_checker: string;
    remarks: string;
  }[];
  manualRepairUpdate: {
    editor_repair_name: string;
    repair_date: string;
    perforation_damges: string;
    open_weak_splice: string;
    tears: string;
    leader_changed: string;
    rfid_tag_can: string;
    rfid_tag_beg_leader: string;
    rfid_tag_end_leader: string;
    next_processing_step_recommended: string;
    remarks: string;
  }[];
  manualCleaning: {
    cleaning_type: string;
    emulsion: string;
    head_tail_position: string;
    molecular_sieves_insertion: string;
  }[];
  dryingOrDesiccation: {
    treatment: string;
    set_up_used_for_dessication_rehydration_along_with_any_specific_setting: string;
    chemicals_used_for_tratment: string;
    no_of_days_for_treatment_in_desiccation_rehydration: string;
    eight_weeks_status_or_condition_after_8_weeks: string;
    next_process_recommed: string;
  }[];
  movementToDesiccation: {
    editor_Checker_Name: string;
    date_Time: string;
    intial_weight: string;
    unwinding_reel_status: string;
    rack_No_in_Chamber: string;
    shelf_No_in_Chamber: string;
  }[];
  followup: {
    indexNumber: number;
    followup_editor_Checker_Name: string;
    followup_DateandTime: string;
    followup_weight: string;
    followup_Unwinding_Reel_status: string;
  }[];
  ultraSonicUCMachineCleaning: {
    date_of_ultra_sonic_machine_cleaning: string;
    name_and_mode_no: string;
    solution_used: string;
    specific_used: string;
    cleaning: string | null; // You might want to specify the correct type here
    emulsion: string;
    head_trail_postion: string;
    molecular_sieves_insertion: string;
  }[];
  rewashMachine: {
    date_of_rewash: string;
    rewash_name_and_model_no: string;
    rewash_machine_setting: string | null; // You might want to specify the correct type here
    chemical_used: string;
    any_other_specific_information: string;
    cleaning: string;
    emulsion: string;
    head_tail_position: string;
    molecular_sieves_insertion: string;
  }[];
  movementBacktoVault: {
    handlers_name: string;
    movemenent_to_vault_date: string;
    before_vault_number: string;
    before_rack_number: string;
    before_shelf_number: string;
    after_vault_number: string;
    after_rack_number: string;
    after_shelf_number: string;
    remark: string;
  }[];
};

export const label = {
  before_vault_number: 'Vault Number',
  before_rack_number: 'Rack Number',
  before_shelf_number: 'Shelf Number',
  after_vault_number: 'Vault Number',
  after_rack_number: 'Rack Number',
  after_shelf_number: 'Shelf Number',
};

export const FollowUpTable = [
  [
    'movementToDesiccation',
    'follow-up_1',
    'follow-up_2',
    'follow-up_3',
    'follow-up_4',
    'follow-up_5',
    'follow-up_6',
  ],
  [
    'follow-up_7',
    'follow-up_8',
    'follow-up_9',
    'follow-up_10',
    'follow-up_11',
    'follow-up_12',
    'follow-up_13',
    'follow-up_14',
    'follow-up_15',
  ],
  [
    'follow-up_16',
    'follow-up_17',
    'follow-up_18',
    'follow-up_19',
    'follow-up_20',
    'follow-up_21',
    'follow-up_22',
    'follow-up_23',
    'follow-up_24',
  ],
  [
    'follow-up_25',
    'follow-up_26',
    'follow-up_27',
    'follow-up_28',
    'follow-up_29',
    'follow-up_30',
    'follow-up_31',
    'follow-up_32',
  ],
];
